import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState
} from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { IChoice } from '@app/open-insurance/open-insurance.model';
import {
  ICONS_ENUM,
  OpenInsuranceIcons
} from '@app/open-insurance/shared/constants/icons';

import { IHandleToggleParams } from '../../atoms/toggle-slider/toggle-slider.model';
import { DialogDetailsComponent } from '../dialog-details/dialog-details.component';
import { IDialogDetail } from '../dialog-details/dialog-details.model';

@Component({
  selector: 'app-opin-consent-card',
  templateUrl: './consent-card.component.html',
  styleUrls: ['./consent-card.component.scss'],
  standalone: false
})
export class OpinConsentCardComponent implements OnInit {
  ICONS = ICONS_ENUM;

  @Input() name: string;
  @Input() title: string;
  @Input() status: boolean;
  @Input() subtitle: string;
  @Input() icon: OpenInsuranceIcons;
  @Input() canToggle = true;
  @Input() choices: IChoice[];
  @Input() details: IDialogDetail;

  @Output() onToggle = new EventEmitter<IHandleToggleParams>();

  friendlyChoices: string;

  isExtraSmall$: Observable<BreakpointState>;

  constructor(
    public dialog: MatDialog,
    private breakpointObserver: BreakpointObserver
  ) {
    this.isExtraSmall$ = this.breakpointObserver.observe(Breakpoints.XSmall);
  }

  ngOnInit() {
    this.friendlyChoices = this.getFriendlyChoices(this.choices);
  }

  handleToggleSlider({ isChecked }: IHandleToggleParams) {
    this.onToggle.emit({
      isChecked,
      name: this.name
    });
  }

  getFriendlyChoices(choices: IChoice[]) {
    const choicesToPermissionList = choices.map((choice) => choice.label);

    if (!choicesToPermissionList.length) return '';

    const labels = choicesToPermissionList.filter((label) => !!label);

    const lastWord = labels.pop();

    const formattedWords = labels.length
      ? `${labels.join(', ')} e ${lastWord}.`
      : `${lastWord}.`;

    return formattedWords;
  }

  openDialog(): void {
    const signInDialogRef = this.dialog.open(DialogDetailsComponent, {
      width: '50%',
      height: '80%',
      maxWidth: '100vw',
      maxHeight: '100vh',
      data: this.details
    });

    const smallDialogSubscription = this.isExtraSmall$.subscribe((result) => {
      if (result.matches) {
        signInDialogRef.updateSize('100%', '100%');
      } else {
        signInDialogRef.updateSize('50%', '80%');
      }
    });

    signInDialogRef
      .afterClosed()
      .pipe(
        tap(() => {
          smallDialogSubscription.unsubscribe();
        })
      )
      .subscribe();
  }
}
